<template>
  <v-dialog v-model="localDialog" max-width="950px" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase d-flex justify-center" style="position: relative">
        GỬI NHẬN XÉT CHO HỌC SINH
        <v-btn dark icon absolute right @click="close" style="top: 8px; right: 8px">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4 black--text" style="background-color: white">
        <!-- Action Buttons -->
        <div class="d-flex align-center flex-wrap mb-4" style="gap: 12px">
          <v-btn class="ma-2" dark depressed color="primary" @click="sendEvaluation" :loading="isSending">Soạn tin</v-btn>
        </div>

        <!-- Extra Checkboxes -->
        <div class="d-flex align-center flex-wrap mb-4" style="gap: 16px">
          <div class="d-flex align-center">
            <v-checkbox
              v-model="includeScores"
              label="Gửi kèm thêm điểm số"
              hide-details
              class="mt-0 pt-0 mr-2"
            ></v-checkbox>
            <v-select
              v-model="semester"
              :items="semesters"
              item-text="title"
              item-value="id"
              outlined
              dense
              hide-details
              style="width: 180px; background-color: white"
              placeholder="Chọn học kì"
            ></v-select>
          </div>
        </div>

        <v-row class="mt-2">
          <!-- Left Columns (Subjects & Score Types) -->
          <v-col cols="12" md="6" class="d-flex pr-0">
            <!-- Subjects -->
            <div style="flex: 1; border: 1px dashed #ccc; background-color: white; border-right: none" class="pa-2">
              <v-checkbox
                v-model="selectAllSubjects"
                label="Môn học"
                hide-details
                class="mt-0 font-weight-bold"
              ></v-checkbox>
              <v-divider class="my-2"></v-divider>
              <div style="max-height: 250px; overflow-y: auto">
                <v-checkbox
                  v-for="subject in subjects"
                  :key="subject.id"
                  v-model="selectedSubjects"
                  :value="subject.id"
                  :label="subject.title"
                  dense
                  hide-details
                  class="mt-1"
                ></v-checkbox>
              </div>
            </div>
            <!-- Score Types -->
            <div style="flex: 1; border: 1px dashed #ccc; background-color: white" class="pa-2 d-flex flex-column">
              <v-checkbox
                v-model="selectAllScoreTypes"
                label="Loại điểm"
                hide-details
                class="mt-0 font-weight-bold"
              ></v-checkbox>
              <v-divider class="my-2"></v-divider>
              <div style="flex-grow: 1; overflow-y: auto; max-height: 210px">
                <v-checkbox
                  v-for="type in scoreTypes"
                  :key="type.id"
                  v-model="selectedScoreTypes"
                  :value="type.id"
                  :label="type.title"
                  dense
                  hide-details
                  class="mt-1"
                ></v-checkbox>
              </div>
              <v-divider class="my-2"></v-divider>
              <v-checkbox
                v-model="onlyNewScores"
                label="Chỉ gửi điểm mới"
                hide-details
                class="font-weight-bold"
              ></v-checkbox>
            </div>
          </v-col>

          <!-- Right Column (Preview) -->
          <v-col cols="12" md="6" class="pl-md-6">
            <div class="font-weight-bold mb-1">Tiêu đề</div>
            <v-text-field v-model="title" outlined dense hide-details style="background-color: white"></v-text-field>

            <div class="font-weight-bold mt-4 mb-1">Mẫu tin nhắn</div>
            <div
              style="
                background-color: #e0e0e0;
                border-radius: 12px;
                padding: 16px;
                min-height: 150px;
                font-family: monospace;
                white-space: pre-wrap;
              "
              v-text="previewMessage"
            ></div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions
        class="justify-center py-3"
        style="background: repeating-linear-gradient(45deg, #f0f0f0, #f0f0f0 10px, #ffffff 10px, #ffffff 20px)"
      >
        <span class="font-weight-bold text-subtitle-2">
          Tin nhắn nhận xét tuần {{ weekRange }} sẽ được gửi cho
          {{ postTos && postTos.students ? postTos.students.length : 0 }} học sinh
        </span>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ContactBook } from '@/plugins/api'
import moment from 'moment'

export default {
  name: 'FastPostCreateReportDialog',
  props: {
    state: Boolean,
    postTos: Object,
    gradeId: String,
    selectedDate: [String, Object, Date]
  },
  data() {
    return {
      localDialog: false,
      isSending: false,
      scheduleType: 'now',
      periodic: false,
      filterBy: 'Theo tuần',
      month: moment().format('M/YYYY'),
      week: '',
      includeScores: true,
      semester: null,
      includeConduct: false,
      includeConductRank: false,
      onlyNewValues: true,
      selectAllSubjects: false,
      selectedSubjects: [],
      selectAllScoreTypes: false,
      selectedScoreTypes: [],
      onlyNewScores: true,
      title: 'HTGD_Lythaito TB:'
    }
  },
  computed: {
    ...mapState('ContactBook', ['evaluationOptions']),
    weekRange() {
      const target = this.selectedDate ? moment(this.selectedDate) : moment()
      const start = target.clone().startOf('isoWeek').format('DD/MM/YY')
      const end = target.clone().endOf('isoWeek').format('DD/MM/YY')
      return `${start} - ${end}`
    },
    subjects() {
      return this.evaluationOptions && this.evaluationOptions.subjects
    },
    scoreTypes() {
      return this.evaluationOptions && this.evaluationOptions.factors
    },
    semesters() {
      return this.evaluationOptions && this.evaluationOptions.semesters
    },
    previewMessage() {
      let msg = `ĐHAn-11A;\n<nội dung nhận xét, đánh giá, nhắc nhở trong tuần>.\n`

      if (this.includeScores && (this.selectedSubjects.length > 0 || this.selectedScoreTypes.length > 0)) {
        let subjectsStr =
          this.selectedSubjects.length > 0
            ? this.subjects
                .filter(s => this.selectedSubjects.indexOf(s.id) > -1)
                .map(s => s.title)
                .join(', ')
            : '<các môn>'
        let scoresStr =
          this.selectedScoreTypes.length > 0
            ? this.scoreTypes
                .filter(f => this.selectedScoreTypes.indexOf(f.id) > -1)
                .map(f => f.title)
                .join(', ')
            : '<các loại điểm>'
        msg += `${subjectsStr}: ${scoresStr}`
      } else {
        msg += `<nội dung điểm học sinh nếu có>`
      }
      return msg
    }
  },
  watch: {
    state(newVal) {
      this.localDialog = newVal
      if (newVal) {
        this.fetchEvaluationOptions(this.gradeId)
      }
    },
    localDialog(newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },
    selectAllSubjects(newVal) {
      if (newVal) {
        this.selectedSubjects = this.subjects.map(s => s.id)
      } else {
        this.selectedSubjects = []
      }
    },
    selectAllScoreTypes(newVal) {
      if (newVal) {
        this.selectedScoreTypes = this.scoreTypes.map(f => f.id)
      } else {
        this.selectedScoreTypes = []
      }
    },
    semesters(newVal) {
      if (newVal && newVal.length > 0 && !this.semester) {
        this.semester = newVal[0].id
      }
    }
  },
  methods: {
    ...mapActions('ContactBook', ['fetchEvaluationOptions']),
    close() {
      this.localDialog = false
      this.$emit('close')
    },
    async sendEvaluation() {
      if (!this.postTos || !this.postTos.students || this.postTos.students.length === 0) {
        this.$alert.error('Không có học sinh nào để gửi!')
        return
      }

      this.isSending = true
      try {
        const payload = {
          students: this.postTos.students.map(s => ({ _id: s._id || s.id })),
          semester: this.semester,
          selectedSubjects: this.selectedSubjects,
          selectedScoreTypes: this.selectedScoreTypes,
          onlyNewScores: this.onlyNewScores,
          title: this.title,
          draftOnly: true
        }

        const res = await ContactBook.sendScoreNotification(payload)
        const responseData = (res && res.data) ? res.data : (res || {})
        const totalSent = responseData.totalSent !== undefined ? responseData.totalSent : (res && res.totalSent !== undefined ? res.totalSent : 0)
        if (totalSent > 0) {
          this.$alert.success(`Đã soạn nội dung tin nhắn thành công cho ${totalSent} học sinh!`)
          const posts = responseData.posts || res.posts || []
          this.$emit('success', posts)
        } else {
          this.$alert.warn('Không có học sinh nào có điểm phù hợp để soạn. Vui lòng kiểm tra lại học kì, môn học và loại điểm đã chọn.')
        }
        this.close()
      } catch (error) {
        this.$alert.error('Lỗi khi soạn tin: ' + (error || 'Không xác định'))
      } finally {
        this.isSending = false
      }
    }
  }
}
</script>

<style scoped>
/* Optional styling to match exact look if needed */
</style>
